<template>
    <div class="form">
        <div class="grid-x">
            <div class="flexbox-center">
                <icon class="small-label-svg" name="supply-type" />
            </div>
            <div class="cell small-8 medium-4 large-4 flexbox align-items">
                <p>Forretningsområde</p>
            </div>
            <div class="cell auto grid-x select-supply">
                <div class="align-items select-supply-container" v-for="supplytype in supplyTypes" :key="supplytype.code" @click="selectSupplyType(supplytype)">
                    <div v-if="!multiple" class="button-radio-round flexbox-center" :id="supplytype.systemName" :class="{'selected-supply': selectedSupplyType.code === supplytype.code}">
                        <icon class="small-svg fill-white" :name="supplytype.systemName | toLowerCase" />
                    </div>
                    <div v-else class="button-radio-round flexbox-center" :id="supplytype.systemName" :class="{'selected-supply': checkSelected(supplytype)}">
                        <icon class="small-svg fill-white" :name="supplytype.systemName | toLowerCase" />
                    </div>
                    <span>{{supplytype.description}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'supplytype',
    props: ['multiple'],
    data () {
        return {}
    },
    computed: {
        ...mapGetters({
            selectedSupplyType: 'selectedSupplyType',
            selectedMultipleSupplyType: 'selectedMultipleSupplyType',
            supplyTypes: 'getSysBusinessAreaTypeList'
        })
    },
    methods: {
        ...mapActions({
            setSelectedSupplyTypeFromId: 'setSelectedSupplyTypeFromId',
            setSelectedMultipleSupplyTypeFromId: 'setSelectedMultipleSupplyTypeFromId',
            clearSelectedMultipleSupplyType: 'clearSelectedMultipleSupplyType'
        }),
        checkSelected (supplytype) {
            let found = false
            this.selectedMultipleSupplyType.forEach(sup => {
                if (sup.code === supplytype.code) {
                    found = true
                }
            })
            return found
        },
        selectSupplyType (supplyType) {
            if (supplyType.sysBusinessAreaTypeId) {
                if (this.multiple) {
                    this.setSelectedMultipleSupplyTypeFromId(supplyType.sysBusinessAreaTypeId)
                } else {
                    this.setSelectedSupplyTypeFromId(supplyType.sysBusinessAreaTypeId)
                }
            }
        }
    },
    created () {
        if (this.multiple) {
            this.clearSelectedMultipleSupplyType()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/supplytype/supplytype.vue